import { hotRankings } from "@/mocks/rankings";
import type { Notice } from "@/pages/home/types";
import SectionHeading from "@/pages/home/components/SectionHeading";

interface RankingSectionProps {
  onOpenNotice: (notice: Notice) => void;
}

const trendIcon: Record<string, { icon: string; color: string }> = {
  up: { icon: "ri-arrow-up-line", color: "text-primary-600" },
  down: { icon: "ri-arrow-down-line", color: "text-secondary-500" },
  flat: { icon: "ri-subtract-line", color: "text-foreground-400" },
};

export default function RankingSection({ onOpenNotice }: RankingSectionProps) {
  const handleOpen = (item: (typeof hotRankings)[number]) => {
    onOpenNotice({
      title: `热瓜榜第 ${item.rank} 位 · ${item.tag}`,
      lines: [
        item.title,
        `热度指数 ${(item.heat / 10000).toFixed(1)} 万，当前排名第 ${item.rank} 位。`,
        "榜单数据为演示用静态内容，用于展示排序与热度模块的呈现方式。",
      ],
      copyText: "51heilian01.top",
      copyLabel: "复制入口地址",
    });
  };

  return (
    <section id="rank" className="w-full bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <SectionHeading
          eyebrow="HOT BOARD"
          title="热瓜榜 · 实时热度 TOP 8"
          desc="按综合热度排序，名次与趋势同步更新；点开任意一条即可查看摘要与当前入口地址。"
          icon="ri-fire-line"
        />

        <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
          {hotRankings.map((item) => {
            const trend = trendIcon[item.trend] ?? trendIcon.flat;
            const isTop = item.rank <= 3;
            return (
              <button
                key={item.id}
                type="button"
                onClick={() => handleOpen(item)}
                className="flex w-full cursor-pointer items-center gap-3 border-b border-background-200 px-4 py-4 text-left transition-colors last:border-b-0 hover:bg-background-100 md:gap-5 md:px-6 md:py-5"
              >
                <span
                  className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-md font-heading text-lg font-black md:h-11 md:w-11 ${
                    isTop ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                  }`}
                >
                  {item.rank}
                </span>

                <div className="min-w-0 flex-1">
                  <h3 className="truncate text-sm font-bold text-foreground-950 md:text-base">{item.title}</h3>
                  <div className="mt-1.5 flex flex-wrap items-center gap-2 md:gap-3">
                    <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-[11px] font-bold text-accent-800">
                      {item.tag}
                    </span>
                    <span className="flex items-center gap-1 text-xs text-foreground-500">
                      <i className="ri-fire-fill text-accent-500"></i>
                      热度 {(item.heat / 10000).toFixed(1)} 万
                    </span>
                  </div>
                </div>

                <span className={`flex items-center gap-1 text-sm font-bold ${trend.color}`}>
                  <i className={trend.icon}></i>
                  <span className="hidden sm:inline">
                    {item.trend === "up" ? "上升" : item.trend === "down" ? "下降" : "持平"}
                  </span>
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}